<script>
import auctionTable from "../components/auctionTable";
import auctionsOverview from "../components/auctionsOverview";

export default {
  name: "dashboard",
  components: {
    auctionTable,
    auctionsOverview,
  },
  data: function() {
    return {
      activeAuctionId: "",
      showAuctionEdit: false,
    };
  },
  methods: {
    onClickNewAuctionCreate: function() {
      this.showAuctionEdit = true;
    },
    onRefreshAuctionTable: function() {},
    onMount: async function() {
      var auctionToBeCreated = this.$store.state.auctionToBeCreatedOnLogin;
      if (!auctionToBeCreated) {
        console.log("rewr");
      }
      if (this.$route.query.create || auctionToBeCreated) {
        //first check that auction does not already exist - if it does, redirect to dashboard without query parameters
        var doesAlreadyExist = await this.$store.dispatch("getRequest", { controller: "auction", method: `DoesAuctionExist/${this.$route.query.create || auctionToBeCreated}` });
        if (auctionToBeCreated) {
          this.$store.commit("auctionToBeCreatedOnLogin", null);
        }
        if (doesAlreadyExist.exists) {
          this.$router.push("/dashboard");
        } else {
          this.$store.commit("setCreate", true);
          var template = await this.$store.dispatch("getRequest", { controller: "auction", method: `template`, parameters: { id: this.$route.query.create || auctionToBeCreated } });
          var now = new Date();
          template.auctionStart = now.addHours(1).toISOString();
          this.$store.commit("setActiveAuction", template);
          this.$store.commit("setAuctionEditVisible", true);
          var requirementsDataSource = await this.$store.dispatch("getRequest", { controller: "requirement", method: `getRequirements`, parameters: { open: false, kvPairs: true } });
          this.$store.commit("setAvailableRequirements", requirementsDataSource);
        }
      } else {
        this.$store.commit("setAuctionEditVisible", false);
        var requirementsDataSource = await this.$store.dispatch("getRequest", { controller: "requirement", method: `getRequirements`, parameters: { open: true, kvPairs: true } });
        this.$store.commit("setAvailableRequirements", requirementsDataSource);
      }
    },
  },
  computed: {},
  mounted: async function() {
    await this.onMount();
  },
};
</script>

<template>
  <div>
    <auctions-overview></auctions-overview>
    <auction-table v-on:refreshAuctionTable="onRefreshAuctionTable"></auction-table>
  </div>
</template>

<style scoped></style>
